const font = 'Helvetica';
const fontBold = 'Helvetica-Bold';
const fontItalic = 'Helvetica-Oblique';
// const font = 'Calibri';
// const fontBold = 'Calibri-Bold';

const styles: any = {
    page: {
        fontFamily: font,
        padding: '40pt 40pt 60pt 40pt',
        fontSize: '11pt',
        display: 'flex',
        flexDirection: 'column'
    },
    katalog_l1: {
        fontSize: '12pt',
        fontFamily: fontBold,
        marginBottom: '5pt',
        display: 'flex',
        flexDirection: 'row'
    },
    katalog_l2: {
        fontSize: '11pt',
        marginBottom: '5pt',
        display: 'flex',
        flexDirection: 'row'
    },
    h1: {
        fontFamily: fontBold,
        fontSize: '16pt',
        fontWeight: 'bold',
        marginTop: '12pt',
        marginBottom: '3pt'
    },
    h2: {
        fontFamily: fontBold,
        fontSize: '12pt',
        fontWeight: 'bold',
        color: '#728a49',
        marginTop: '12pt',
        marginBottom: '3pt'
    },
    div: {
        marginBottom: '8pt',
        wordBreak: 'break-word',
        whiteSpace: 'pre-line'
    },
    list: {
        marginLeft: '20pt'
    },
    list_number: {
        width: '20pt',
        minWidth: '20pt'
    },
    list_alphabet: {
        width: '20pt',
        minWidth: '20pt',
        fontWeight: 'bold',
        fontFamily: fontBold
    },
    bold: {
        fontWeight: 'bold',
        fontFamily: fontBold
    },
    italic: {
        fontFamily: fontItalic,
        fontStyle: 'italic'
    },
    deckblattTitle: {
        zIndex: 100,
        position: 'absolute',
        left: '46pt',
        top: '192pt',
        fontSize: '30pt',
        color: '#444'
    },
    deckblattTitleJahr: {
        zIndex: 100,
        position: 'absolute',
        left: '380pt',
        top: '151pt',
        fontSize: '34pt',
        color: '#444'
    },
    deckblattTitleJahrNum: {
        fontFamily: font,
        lineHeight: 1,
        fontSize: '34pt',
        width: '100pt',
        height: '50pt'
    },
    deckblattTitleFirmenname: {
        fontFamily: fontBold,
        fontWeight: 'bold',
        lineHeight: 1,
        fontSize: '23pt',
        width: '500pt',
        height: '50pt'
    },
    deckblattLogo: {
        zIndex: 100,
        position: 'absolute',
        top: '45pt',
        right: '36pt',
        // bottom: '45pt',
        // left: '40pt',
        width: 'auto',
        height: '60pt',
    },
    header: {
        width: '100%',
        height: 60,
        top: -10,
        left: 0,
        padding: 0,
        position: 'relative',
        display: 'block',
        // borderBottom: '1pt solid #000',
        fontSize: '14pt',
        color: '#555',
        fontFamily: fontBold
    },
    headerFirmenname: {
        color: '#728a49'
    },
    headerStandort: {
        // fontSize: '10pt',
        // color: '#548dd4'
    },
    headerLogo: {
        width: 'auto',
        height: '35pt',
        top: 0,
        right: 0,
        position: 'absolute',
        display: 'inline-block'
    },
    headerFirma: {
        maxWidth: 80,
        height: '35pt',
        objectFit: 'contain',
        top: 0,
        right: 70,
        position: 'absolute',
        display: 'inline-block'
    },
    footer: {
        position: 'absolute',
        width: '100%',
        bottom: '25pt',
        left: '40pt',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderTop: '1pt solid #000',
        paddingTop: '8pt'
    },
    footer_multi: {
        position: 'absolute',
        width: '100%',
        bottom: '25pt',
        left: '40pt',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        borderTop: '1pt solid #000',
        paddingTop: '8pt'
    },
    footer_multi_inner: {
        // position: 'absolute',
        width: '100%',
        // bottom: '25pt',
        // left: '40pt',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        // borderTop: '1pt solid #000',
        // paddingTop: '8pt'
    },
};

export function getStyle(key: string, pdf = true): any {
    const style = { ...styles[key] || {} };
    if (!pdf) {
        delete style.fontFamily;
    }
    return style;
}
